import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import RoutesBase from "./RoutesBase";
import theme from "./theme";
import { useGetProfileQuery, useValidateQuery } from "./slices/twitchApiSlice";
import { setCredentials } from "./slices/userSlice";

const App = () => {
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.theme.darkMode);
  const { user, hasToken } = useSelector((state) => state.user);
  const { data } = useGetProfileQuery(undefined, { skip: !hasToken });
  const { refetch } = useValidateQuery(undefined, {
    skip: !user || !hasToken,
  });

  useEffect(() => {
    let interval;

    if (user && hasToken) {
      interval = setInterval(() => {
        refetch();
      }, 1000 * 60 * 60 * 1);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [user, hasToken, refetch]);

  useEffect(() => {
    if (data) {
      dispatch(setCredentials({ ...data.user }));
    }
  }, [dispatch, data]);

  return (
    <ThemeProvider theme={theme(darkMode)}>
      <CssBaseline />
      <RoutesBase />
    </ThemeProvider>
  );
};

export default App;
